import { useQuery } from '@apollo/client';

import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';
import type {
  UseCalendarEventsQuery as UseCalendarEventsQueryData,
  UseCalendarEventsQueryVariables,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useCalendarEvents';
import UseCalendarEventsQuery from 'bundles/degree-home/components/v3-dpm/lib/__queries__/useCalendarEvents.graphql';

const useCalendarEvents = () => {
  const { degreeId } = useDegreeContext();

  const variables: UseCalendarEventsQueryVariables = {
    degreeId,
  };

  return useQuery<UseCalendarEventsQueryData, UseCalendarEventsQueryVariables>(UseCalendarEventsQuery, {
    variables,
    context: { clientName: 'gatewayGql' },
  });
};

export default useCalendarEvents;
